import {Component, Host, h, Prop, Event, type EventEmitter} from '@stencil/core';
import type {BooleanString} from '../../../models/common/types/boolean-string.type';

@Component({
  tag: 'facets-block-controls',
  styleUrl: 'facets-block-controls.scss',
  shadow: true,
})
export class FacetsBlockControls {
  @Prop({attribute: 'show-reset'}) readonly showReset: BooleanString;
  @Prop() readonly facetsLabel?: string;
  @Prop() readonly resetLabel?: string;

  @Event({ eventName: 'search:reset' }) searchReset: EventEmitter<void>;

  get isShowReset() {
      return this.showReset && this.showReset === 'true';
  }

  render() {
      return (
        <Host>
          <qds-title layer="main" level="root" tag="h3" alignment="start">
            {this.facetsLabel}
          </qds-title>

          {this.isShowReset ?
            <qds-button
              disabled={false}
              type="button"
              onClick={() => this.searchReset.emit()}
              text={this.resetLabel}
              iconName="arrow-circular-clockwise"
              importance="subdued"
              size="medium"
            /> : ''}
        </Host>
      );
  }

}
